import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/modelosDeLiquidacion/modelsLiquidation";
import concepts from "../../store/conceptos/concepts";
import costCenters from "../centrosDeCosto/costCenters";
import rulesLiquidations from "@/store/modelosDeLiquidacion/rulesLiquidation";
import operators from "@/store/workflow/operators";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    modelsLiquidations: [],
    open: false,
    mode: "Agregar modelos de liquidación",
    new: {},
    edit: {},
    editRelation: {},
    itemDelete: null,
    openDelete: false,
    showCard: false,
    showTable: false,
    openFormRelation: false,
    modeFormRelation: "",
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setModelsLiquidations(state, data) {
      state.modelsLiquidations = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setShowCard(state, data) {
      state.showCard = data;
    },
    setShowTable(state, data) {
      state.showTable = data;
    },
    setOpenFormRelation(state, data) {
      state.openFormRelation = data;
    },
    setModeFormRelation(state, data) {
      state.modeFormRelation = data;
    },
    setEditRelation(state, data) {
      state.editRelation = data;
    },
  },
  actions: {
    async getLiquidationModels(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLiquidationModels();
          state.commit("setModelsLiquidations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getLiquidationModelId({ state, commit }, liqModelId) {
      try {
        const data = await state.service.getLiquidationModelId(liqModelId);
        data.id = liqModelId;

        commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async add(state) {
      try {
        await state.state.service
          .addLiquidationModel(state.state.new)
          .then(async () => {
            await state.dispatch("getLiquidationModels");
          });
        return true;
      } catch (error) {
        throw error;
      }
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteLiquidationModel(state.state.itemDelete)
            .then(() => {
              let options = state.state.modelsLiquidations;

              options = options.filter((option) => {
                return option.liqmodelId != state.state.itemDelete;
              });
              state.commit("setModelsLiquidations", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editLiquidationModel(state.state.editRelation)
            .then(() => {
              let item = state.state.edit;
              let newItem = state.state.editRelation;

              for (const key in item) {
                if (item[key] !== newItem[key]) {
                  item[key] = newItem[key];
                }
              }

              state.commit("setEdit", item);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //intancias
    async addInstance(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addInstanceToLiquidation(
            state.state.new
          );
          const newItem = response.data;

          if (!state.state.edit.instancias) {
            const updatedEdit = {
              ...state.state.edit,
              instancias: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              instancias: [...state.state.edit.instancias, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteInstance(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteInstanceToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.instancias;

              options = options.filter((option) => {
                return (
                  option.fecDesde !==
                  state.state.itemDelete.dateStartInput + "T00:00:00.000Z"
                );
              });

              let edit = { ...state.state.edit };
              edit.instancias = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editInstance(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.editInstanceToLiquidation(
            state.state.editRelation
          );
          let item = state.state.editRelation;
          let options = state.state.edit.instancias;

          const index = options.findIndex(
            (option) => option.fecDesde === item.fecDesdeOld
          );

          if (index !== -1) {
            const updatedItem = { ...options[index] };
            if (item.name !== item.nombre) {
              updatedItem.nombre = item.name;
            }
            if (
              item.dateStartInput &&
              item.dateStartInput + "T00:00:00.000Z" !== item.fecDesde
            ) {
              updatedItem.fecDesde = item.dateStartInput + "T00:00:00.000Z";
            }
            if (
              item.dateEndInput &&
              item.dateEndInput + "T00:00:00.000Z" !== item.fecHasta
            ) {
              updatedItem.fecHasta = item.dateEndInput;
            }
            if (item.repitXyear !== item.repiteXanio) {
              updatedItem.repiteXanio = item.repitXyear;
            }
            if (item.overtimeLimit !== item.topeMaxHExtras) {
              updatedItem.topeMaxHExtras = item.overtimeLimit;
            }
            options[index] = updatedItem;
          }

          let edit = { ...state.state.edit };
          edit.instancias = options;
          state.commit("setEdit", edit);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },

    //conceptos
    async addConcept(state) {
      try {
        const response = await state.state.service.addConceptToLiquidation(
          state.state.new
        );

        const newItem = response.data;

        const item = concepts.state.concepts.find(
          (item) => item.conceptId === newItem.conceptoId
        );
        const formattedNew = {
          ...newItem,
          nombre: item.name,
          fixed: Number(state.state.new.idAutorizacion),
        };
        const updatedEdit = {
          ...state.state.edit,
          conceptos: [...state.state.edit.conceptos, formattedNew],
        };
        state.commit("setEdit", updatedEdit);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteConceptToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.conceptos;

              options = options.filter((option) => {
                return option.conceptoId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.conceptos = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editConceptToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.conceptos;

              const index = options.findIndex(
                (option) => option.conceptoId === Number(item.id)
              );

              if (index !== -1) {
                options[index].autoriza = Number(item.autoriza);
              }

              let edit = { ...state.state.edit };
              edit.conceptos = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //centro de costos

    async addCostCenter(state) {
      try {
        const response = await state.state.service.addCostCenterToLiquidation(
          state.state.new
        );
        const newItem = response.data;
        const item = costCenters.state.costCenters.find(
          (item) => item.id === newItem.csCostos[0]
        );

        const formattedNew = {
          csCostoId: item.id,
          nombre: item.name,
        };

        if (!state.state.edit.csCostos) {
          const updatedEdit = {
            ...state.state.edit,
            csCostos: [formattedNew],
          };

          state.commit("setEdit", updatedEdit);
        } else {
          const updatedEdit = {
            ...state.state.edit,
            csCostos: [...state.state.edit.csCostos, formattedNew],
          };

          state.commit("setEdit", updatedEdit);
        }

        return true;
      } catch (error) {
        throw error;
      }
    },
    async deleteCostCenter(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteCostCenterToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.csCostos;
              options = options.filter((option) => {
                return option.csCostoId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.csCostos = options;
              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //empleados
    async addEmployee(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addEmployeeToLiquidation(
            state.state.new
          );
          const newItem = response.data;
          const nameEmployee = this.$store.state.employees.employees.filter(
            (employee) => employee.empId === newItem.empId
          );
          if (nameEmployee.length > 0) {
            newItem.nombre =
              nameEmployee[0].lastName + " " + nameEmployee[0].name;
          }
          if (!state.state.edit.empleados) {
            const updatedEdit = {
              ...state.state.edit,
              empleados: [newItem],
            };
            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              empleados: [...state.state.edit.empleados, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteEmployee(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteEmployeeToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.empleados;
              options = options.filter((option) => {
                return !(
                  option.empId === state.state.itemDelete.id &&
                  option.fecDesde ===
                    state.state.itemDelete.dateStartInput + "T00:00:00.000Z"
                );
              });
              let edit = { ...state.state.edit };
              edit.empleados = options;
              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //empleados

    async editEmployee(state) {
      try {
        const item = state.state.editRelation;
        await state.state.service.editEmployeeToLiquidation(item);

        const data = await state.state.service.getLiquidationModelId(
          item.liqModeloId
        );

        const updatedEdit = {
          ...state.state.edit,
          empleados: data.empleados,
        };
        state.commit("setEdit", updatedEdit);

        return true;
      } catch (error) {
        throw error;
      }
    },

    //grupos

    async addGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addGroupToLiquidation(
            state.state.new
          );
          const newItem = response.data;
          const nameGroup = this.$store.state.changeGroup.group.item.filter(
            (item) => item.groupId === newItem.grupoId
          );

          if (nameGroup.length > 0) {
            newItem.nombre = nameGroup[0].name;
          }

          if (!state.state.edit.grupos) {
            const updatedEdit = {
              ...state.state.edit,
              grupos: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              grupos: [...state.state.edit.grupos, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteGroupToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.grupos;
              options = options.filter((option) => {
                return option.grupoId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.grupos = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editGroupToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.grupos;

              options = options.map((option) => {
                if (option.grupoId !== Number(item.id)) {
                  return option;
                }
                item = {
                  fecDesde: item.itemsForm.dateStartInput,
                  fecHasta: item.itemsForm.dateEndInput,
                  grupoId: item.id,
                  nombre: item.nombre,
                };
                return item;
              });

              let edit = { ...state.state.edit };
              edit.grupos = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //firmas

    async addFirm(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addFirmToLiquidation(
            state.state.new
          );
          const newItem = response.data;

          const nameOperator = operators.state.operators.filter(
            (item) => item.operId === Number(newItem.operId)
          );

          if (nameOperator.length > 0) {
            newItem.nombre = nameOperator[0].nombre;
          }

          if (!state.state.edit.firmas) {
            const updatedEdit = {
              ...state.state.edit,
              firmas: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              firmas: [...state.state.edit.firmas, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteFirm(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteFirmToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.firmas;

              options = options.filter((option) => {
                return option.operId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.firmas = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editFirm(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editFirmToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.firmas;
              options = options.map((option) => {
                if (option.operId !== item.operId) {
                  return option;
                }
                item = {
                  nombre: item.name,
                  operId: item.operId,
                  orden: item.order,
                };

                return item;
              });

              let edit = { ...state.state.edit };
              edit.firmas = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //reglas pre liquidación
    async addRulePreLiquidation(state) {
      try {
        const response =
          await state.state.service.addRulePreLiquidationToLiquidation(
            state.state.new
          );
        const newItem = response.data;

        const updatedEdit = {
          ...state.state.edit,
          reglasPreLiq: [...state.state.edit.reglasPreLiq, newItem],
        };

        state.commit("setEdit", updatedEdit);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteRulePreLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRulePreLiquidationToLiquidation(state.state.itemDelete)
            .then(async () => {
              const data = await state.state.service.getLiquidationModelId(
                state.state.edit.id
              );

              const updatedEdit = {
                ...state.state.edit,
                reglasPreLiq: data.reglasPreLiq,
              };
              state.commit("setEdit", updatedEdit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editRulePreLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editRulePreLiquidationLiquidation(state.state.editRelation)
            .then(async () => {
              const data = await state.state.service.getLiquidationModelId(
                state.state.edit.id
              );

              const updatedEdit = {
                ...state.state.edit,
                reglasPreLiq: data.reglasPreLiq,
              };
              state.commit("setEdit", updatedEdit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //reglas de liquidación

    async addRuleLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response =
            await state.state.service.addRuleLiquidationToLiquidation(
              state.state.new
            );
          const newItem = response.data;

          const nameRuleLiquidation =
            rulesLiquidations.state.rulesLiquidations.filter(
              (item) => item.id === newItem.reglaLiqId
            );

          if (nameRuleLiquidation.length > 0) {
            newItem.nombre = nameRuleLiquidation[0].name;
          }

          if (!state.state.edit.reglasLiq) {
            const updatedEdit = {
              ...state.state.edit,
              reglasLiq: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              reglasLiq: [...state.state.edit.reglasLiq, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteRuleLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRuleLiquidationToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.reglasLiq;

              options = options.filter((option) => {
                return option.reglaLiqId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.reglasLiq = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editRuleLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const item = state.state.editRelation;
          await state.state.service.editRuleLiquidationToLiquidation(item);

          const data = await state.state.service.getLiquidationModelId(
            item.liqModeloId
          );

          const updatedEdit = {
            ...state.state.edit,
            reglasLiq: data.reglasLiq,
          };
          state.commit("setEdit", updatedEdit);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    //reglas de ajuste

    async addRuleAdjustment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response =
            await state.state.service.addRuleAdjustmentToLiquidation(
              state.state.new
            );
          const newItem = response.data;

          if (!state.state.edit.reglasAjuste) {
            state.state.edit.reglasAjuste = [];
          }

          const updatedEdit = {
            ...state.state.edit,
            reglasAjuste: [...state.state.edit.reglasAjuste, newItem],
          };

          state.commit("setEdit", updatedEdit);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteRuleAdjustment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRuleAdjustmentToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.reglasAjuste;

              let item = state.state.itemDelete;
              options = options.filter((option) => {
                return option.orden !== item.order;
              });

              let edit = { ...state.state.edit };
              edit.reglasAjuste = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editRuleAdjustment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editRuleAdjustmentToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.reglasAjuste;

              options = options.map((option) => {
                if (option.orden !== item.orderOld) {
                  return option;
                }
                item = {
                  activa: item.itemsForm.activa,
                  nomProc: item.itemsForm.nameProcedure,
                  descrip: item.itemsForm.description,
                  orden: item.itemsForm.order,
                };

                return item;
              });

              let edit = { ...state.state.edit };
              edit.reglasAjuste = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
